import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Users.css";
import { FaEye } from "react-icons/fa";
import Sidebar from "../Layout/Sidebar";
import Header from "../Layout/Header";
import { API_BASE } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";
import UserTabs from "./UserTabs";

const UserRegistrations = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  const getTenantUser = () => {
    try {
      const tenantUser = localStorage.getItem("tenant_user");

      if (!tenantUser) {
        console.error("tenant_user not found in localStorage.");
        return null;
      }

      const parsedTenantUser = JSON.parse(tenantUser);

      console.log("Tenant User from localStorage:", parsedTenantUser);

      return parsedTenantUser;
    } catch (error) {
      console.error("Error reading tenant_user from localStorage:", error);
      return null;
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const tenantUser = getTenantUser();

      if (!tenantUser) {
        return;
      }

      const tenantId = tenantUser.tenant_id;

      if (!tenantId) {
        console.error("Tenant ID not found in tenant_user.");
        return;
      }

      console.log("Tenant ID:", tenantId);

      const apiUrl = `${API_BASE}/users/?tenant=${tenantId}&type=general`;

      console.log("Surveyors API URL:", apiUrl);

      const res = await axios.get(apiUrl);

      console.log("Surveyors API Response:", res);
      console.log("Surveyors API Response Data:", res.data);

      const Users = res.data?.data || [];

      console.log("Surveyors Data:", Users);

      setUsers(Users);
    } catch (error) {
      console.error("Error fetching users:", error);

      if (error.response) {
        console.error("API Error Response:", error.response);
        console.error("API Error Data:", error.response.data);
        console.error("API Error Status:", error.response.status);
      }
    }
  };

  const handleView = (user) => {
    navigate(`/user-view/${user.id}`);
  };

  return (
    <div className="app-layout">
      <Sidebar />

      <div className="main-content">
        <Header />

        <div className="tenant-users-container">
          <UserTabs/>
          <h2 className="tenant-users-title">Oceanstar Surveyors</h2>

          <table className="tenant-users-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Stage1 Status</th>
                <th>Stage2 Status</th>
                <th>Joined Date</th>
                <th>Role</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {users.length > 0 ? (
                users.map((user, index) => (
                  <tr key={user.id}>
                    <td>{index + 1}</td>

                    <td>{user.email}</td>

                    <td>
                      {user.mobile_country_code} {user.mobile_number}
                    </td>

                    <td className="tenant-users-approved">
                      {user.registration_application_status}
                    </td>

                    <td className="tenant-users-approved">
                      {user.professional_profile_status}
                    </td>

                    <td>
                      {user.date_joined
                        ? new Date(user.date_joined).toLocaleDateString()
                        : "—"}
                    </td>

                    <td>
                      {user.role && user.role.length > 0
                        ? user.role
                            .map((r) => {
                              if (r === 2) return "Admin";
                              return "User";
                            })
                            .join(", ")
                        : "Not Specified"}
                    </td>

                    <td>
                      <FaEye
                        className="tenant-users-view-icon"
                        style={{
                          cursor: "pointer",
                          color: "#007bff"
                        }}
                        onClick={() => handleView(user)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="tenant-users-no-data">
                    No Surveyors Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserRegistrations;